"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryAnalysisModeSchema = exports.BoundaryAnalysisMode = void 0;
const zod_1 = require("zod");
var BoundaryAnalysisMode;
(function (BoundaryAnalysisMode) {
    BoundaryAnalysisMode["PossibleValues"] = "possible";
    BoundaryAnalysisMode["PermissibleValues"] = "permissible";
})(BoundaryAnalysisMode || (exports.BoundaryAnalysisMode = BoundaryAnalysisMode = {}));
exports.BoundaryAnalysisModeSchema = zod_1.z.nativeEnum(BoundaryAnalysisMode);
//# sourceMappingURL=BoundaryAnalysisMode.js.map